<div class="release-notes-dialog">
  <div class="dialog-header">
    <h2>Release Notes</h2>
    <button mat-icon-button (click)="dialogRef.close()" class="close-button" tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content cdkFocusInitial>
    <markdown [data]="data.content" class="release-notes-content"></markdown>
  </mat-dialog-content>
</div>
